import React from "react";
import {ConfirmationModal} from "../../../confirmationModal/ConfirmationModal";
import {useAppDispatch} from "../../../../../app/hooks";
import {reimportVehicles} from "../../../../modules/assistant/botSlice";

interface ConfirmationModalProps {
    publicId: string
    handleClose: (value?: any) => any
}

export const ReimportVehiclesConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                                        publicId,
                                                                                        handleClose,
                                                                                    }) => {
    const dispatch = useAppDispatch()

    const handleReimport = () => {
        dispatch(reimportVehicles(publicId))
        handleClose()
    }

    return <ConfirmationModal
        title={"Reimport vehicles"}
        subtitle={"Are you sure you want to reimport all vehicles for this assistant? This process may take some time, during which the assistant might not be able to provide accurate vehicle information."}
        closeButtonTitle={"No, cancel"}
        confirmButtonTitle={"Yes, reimport"}
        onConfirm={handleReimport}
        onClose={handleClose}
    />
}
